import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { useSingleCache } from '@/data/hook/query/v2/useCacheManager';
import { courseModulesQueryKeys } from '@/data/services/querykeys';
import { CourseModule } from '@/models/CourseModule';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

const useModuleWorkspace = () => {
  const { courseLineId: courseLineParam, moduleId: moduleParam } = useParams();
  const isNew = moduleParam === 'new';
  const courseLineId = Number(courseLineParam);
  const moduleId = Number(moduleParam);

  const moduleQueryKey = courseModulesQueryKeys.get(courseLineId, moduleId);

  const { data: module, isLoading: isLoadingModule } = useQuery({
    ...moduleQueryKey,
    enabled: !!courseLineId && !!moduleId && !isNew,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  const cache = useSingleCache<CourseModule>(moduleQueryKey.queryKey);

  const isLoading = isLoadingModule && !!moduleId;

  return {
    module,
    courseLineId,
    moduleId,
    isLoading,
    cache,
  };
};

export default useModuleWorkspace;
